angular.module("questionarioQCC.components",[])
.component("questionarioQcc",{
    templateUrl: 'ng/components/riepilogoEControllo/questionarioQCC/questionarioQCC.view.html',
    bindings:{
        model:'<',
        verifica:'=',
        readOnly:'<'
    },
    controller: QuestionarioQcc,
    controllerAs: 'questionarioQccCtrl'
})

function QuestionarioQcc(
    $configService
){
    var self= this;

    self.$onInit = function(){

    }

    self.check= function(el){
        el.selected =!el.selected
        if(el.selected){
            el.ndg= $configService.getUser().ndg;
            el.identifier= $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        }else{
            el.ndg= "";
            el.identifier= "";
            el.dataConferma = "";
        }
    }
}